import React from 'react'
import PropTypes from 'prop-types'

class ActiveChatroomFilter extends React.Component {
  state = {
    activeChatroomFilter: this.props.activeChatroomFilter
  }

  changeActiveChatroomFilter = (e) => {
    this.setState({ activeChatroomFilter: e.target.value })
    this.props.changeActiveChatroomFilter(e.target.value);
  }

  render() {
    return(
      <div className={this.props.selectClassName}>
        <select className='form-control'
                title='Locations'
                value={this.state.activeChatroomFilter}
                onChange={(e) => this.changeActiveChatroomFilter(e)}>
          <option value='1'>
            Active Chats
          </option>
          <option value='0'>
            Archived Chats
          </option>
        </select>
      </div>
    )
  }
}

ActiveChatroomFilter.propTypes = {
  activeChatroomFilter: PropTypes.number,
  selectClassName: PropTypes.string,
  changeActiveChatroomFilter: PropTypes.func
}

export default ActiveChatroomFilter
